export default __webpack_public_path__ + "static/media/EncodersImg.266abcb7.jpg";